<template>
  <div class="circle-popup">
    <table class="table table-sm table-bordered">
      <tr><td>tag</td><td>{{ data.tag }}</td></tr>
      <tr><td>code</td><td>{{ data.code }}</td></tr>
      <tr><td>time</td><td>{{ data.time }}</td></tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  }
};
</script>